'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabIconStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.tabs.icon,
      width = _theme$reactackle$com.width,
      height = _theme$reactackle$com.height,
      imgSize = _theme$reactackle$com.imgSize;
  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height || width), (0, _reactackleCore.getValueString)(imgSize || height), (0, _reactackleCore.getValueString)(width || height)));
};

var style = function style(_ref2) {
  var themeFromProvider = _ref2.theme,
      selected = _ref2.selected,
      colorScheme = _ref2.colorScheme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.tabs.icon.style[colorScheme];
  return !selected ? (0, _styledComponents.css)(['', ';&:hover{color:', ';}&:focus{color:', ';}'], (0, _reactackleIcons.iconStyleMixin)(source.color), source.hover.color, source.focus.color) : (0, _styledComponents.css)(['       &,&:hover,&:focus{', ';}'], (0, _reactackleIcons.iconStyleMixin)(source.selected.color));
};

var TabIconStyled = exports.TabIconStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TabIconStyled'
})(['margin-left:auto;margin-right:auto;display:flex;', ' ', ';'], size, style);

TabIconStyled.displayName = 'TabIconStyled';